var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4D55",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.538 2.423H4.423A2.923 2.923 0 0 0 1.5 5.346v10.231A2.923 2.923 0 0 0 4.423 18.5h10.23a2.923 2.923 0 0 0 2.924-2.923v-3.115"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4D55",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.846 8.808a3.654 3.654 0 1 0 0-7.308 3.654 3.654 0 0 0 0 7.308"
  })));
};
export default SvgNotification;